export default "__VITE_ASSET__Dpe2jPD2__"